import React from 'react'

function NoDateFound(props) {
    const { message , subMessage } = props;
    return (
        <>
            <div className='No-date-found'>
                <img src="/images/png/no-date.png" className='d-flex m-auto justify-content-center' alt="" />
                <h5>{message ?? "No Data Found"}</h5>
                <h6>{subMessage ?? "It looks like there's nothing here yet. Start adding new items to get things rolling!"}</h6>
            </div>
        </>
    )
}

export default NoDateFound